import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54e96868")

_pushScopeId("data-v-54e96868")
const _hoisted_1 = {
  class: "d-flex flex-column justify-content-between modal_preview",
  style: {"background-color":"black"}
}
const _hoisted_2 = {
  key: 0,
  class: "div_container"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex justify-content-around" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.isAppImage && !_ctx.videoUrl)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.file,
                alt: ""
              }, null, 8, ["src"]))
            : (_ctx.isAppImage && _ctx.videoUrl)
              ? (_openBlock(), _createBlock("video", {
                  key: 1,
                  preload: "none",
                  class: "postVideo",
                  poster: _ctx.preview,
                  controls: ""
                }, [
                  _createVNode("source", {
                    src: _ctx.videoUrl,
                    type: _ctx.file.type
                  }, null, 8, ["src", "type"])
                ], 8, ["poster"]))
              : (_ctx.file.type.match('image'))
                ? (_openBlock(), _createBlock("img", {
                    key: 2,
                    src: _ctx.preview
                  }, null, 8, ["src"]))
                : (_ctx.file.type.match('video'))
                  ? (_openBlock(), _createBlock("video", {
                      key: 3,
                      preload: "none",
                      class: "postVideo",
                      poster: _ctx.preview,
                      controls: ""
                    }, [
                      _createVNode("source", {
                        src: _ctx.videoUrl,
                        type: _ctx.file.type
                      }, null, 8, ["src", "type"])
                    ], 8, ["poster"]))
                  : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3)),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-big square btn-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_annulla',
          text: 'Annulla'
        })
      ]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-big square btn-cyan",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: 'app_invia',
          text: 'Invia'
        })
      ])
    ])
  ]))
})